export const OVERVIEW_DUMMY_DATA = [
  {
    spaceIcon: "/img/widgets/spaces/space-icon-1.png",
    name: "Marketing Team Workspace",
    description:
      "Central hub for all marketing campaigns, content plans, branding...",
    authorName: "Emma Larsson",
  },
  {
    spaceIcon: "/img/widgets/spaces/space-icon-2.png",
    name: "IT & Support Hub",
    description:
      "Internal support center with categorized knowledge base articles, troubles...",
    authorName: "Jane Rotanson",
  },
  {
    spaceIcon: "/img/widgets/spaces/space-icon-3.png",
    name: "Design & Brand Studio",
    description:
      "A visual workspace for designers and brand guardians to store design...",
    authorName: "Hannah Müller",
  },
  {
    spaceIcon: "/img/widgets/spaces/space-icon-4.png",
    name: "People & Culture",
    description:
      "A dedicated space for HR initiatives, onboarding programs, company cult...",
    authorName: "Rajiv Mehta",
  },
];
